export default "__VITE_PUBLIC_ASSET__e1c56430__"